module.exports = __webpack_public_path__ + "assets/images/project/china-desktop.jpg?v=13781ec9";